import React, { useRef, useState } from "react";
import { useResizeObserver } from "usehooks-ts";

import { Text } from "@performyard/py-components";

import VerticalExpander from "../../../../../components/AnimationWrappers/VerticalExpander";
import Button from "../../../../../components/Button";
import Spacer from "../../../../../components/Spacer";
import { useMeetingContext } from "./MeetingContext";
import MeetingOptionsDropdown from "./MeetingOptionsDropdown";

const MeetingDetails = () => {
	const { meeting, userId, setEditingMeeting, isAdminView } = useMeetingContext();
	const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
	const ref = useRef<HTMLDivElement>(null);
	const { height = 0 } = useResizeObserver<HTMLDivElement>({
		ref,
	});

	const hasDescription = meeting.description && meeting.description.trim().length > 0;

	return (
		<div className="space-y-2">
			<div className="flex flex-row items-center justify-between">
				<Text size="paragraph-3" weight="semi-bold">
					Meeting Details
				</Text>
				{!isAdminView && (
					<MeetingOptionsDropdown meeting={meeting} userId={userId} setEditingMeeting={setEditingMeeting} />
				)}
			</div>
			{hasDescription && (
				<div>
					<VerticalExpander
						isExpanded={isDescriptionExpanded}
						closedHeight={48}
						className="whitespace-pre-line"
					>
						<div ref={ref}>
							<Text size="paragraph-3" weight="regular" dangerouslySetClassName="whitespace-pre-line">
								{meeting.description}
							</Text>
						</div>
					</VerticalExpander>
					{height > 48 && (
						<div>
							<Spacer height={1} />
							<Button
								color="gray"
								size="micro"
								onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
							>
								{isDescriptionExpanded ? "Read Less" : "Read More"}
							</Button>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default MeetingDetails;
